import React, { ReactNode, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useHeader } from '../contexts/HeaderContext';
import Sidebar from './Menu';
import { useSetting } from '../contexts/SettingContext';
import { useAuth } from '../contexts/AuthContext';

const Layout: React.FC = () => {
  const navigate = useNavigate();
  const { header } = useHeader();
  const { fetchSettings } = useSetting();
  const { loggedIn } = useAuth();
  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <div className="flex h-screen">
      <Sidebar></Sidebar>

      <div className="flex flex-col flex-grow">
        {/* <AppBar position='static'>
            <Toolbar>
              <Typography variant="h6">{header}</Typography>
            </Toolbar>
          </AppBar> */}

        <div className='p-4 ml-0 flex-grow'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
